import React, { useMemo, useState } from 'react';
import { InlineInputCardWrapper } from '@/features/editor/widgets/shared/ai-editing-layout/inputs/shared/shared';
import { toCssDeclarationName } from '@/features/editor/widgets/shared/ai-editing-layout/inputs/shared/css-declarations';
import { ColorSelectInput } from '@/features/editor/widgets/shared/ai-editing-layout/inputs/shared/color-select-input';
import { parseCssColorToRgba } from '@/features/editor/widgets/shared/ai-editing-layout/inputs/parsers';

export interface CssColorInputProps {
  name: string;
  initialValue?: string;
  onChange?: (name: string, value: string) => void;
}

export function CssColorInput({
  name,
  initialValue,
  onChange,
}: CssColorInputProps) {
  const displayName = useMemo(() => toCssDeclarationName(name), [name]);

  const defaultValue = useMemo(() => {
    if (!initialValue) return `rgba(0, 0, 0, 0)`;
    if (initialValue.startsWith(`linear-gradient`)) {
      return initialValue;
    }
    if (initialValue.startsWith(`radial-gradient`)) {
      return initialValue;
    }
    const rgba = parseCssColorToRgba(initialValue);
    return `rgba(${rgba?.r ?? 0}, ${rgba?.g ?? 0}, ${rgba?.b ?? 0}, ${
      rgba?.a ?? 1
    })`;
  }, [initialValue]);

  const [color, setColor] = useState(defaultValue);

  const onChangeHandler = (colorStr: string) => {
    if (onChange) {
      setColor(colorStr);
      onChange(name, colorStr);
    }
  };

  return (
    <InlineInputCardWrapper>
      <span>{displayName}</span>
      <ColorSelectInput
        initialValue={color}
        onChange={onChangeHandler}
        showHeader={name === `background`}
      />
    </InlineInputCardWrapper>
  );
}
